import { render, staticRenderFns } from "./QRCodeGrantCard.vue?vue&type=template&id=127ead1e&scoped=true"
import script from "./QRCodeGrantCard.vue?vue&type=script&lang=js"
export * from "./QRCodeGrantCard.vue?vue&type=script&lang=js"
import style0 from "./QRCodeGrantCard.vue?vue&type=style&index=0&id=127ead1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127ead1e",
  null
  
)

export default component.exports